<template>
  <FullPageLayout>
    <div class="mx-auto max-w-[960px] w-full py-16 px-1 sm:px-0">
      <h3 class="font-bold text-lg mb-4">{{ $t('main.rss-title') }}</h3>
      <div>
        <ul>
          <li
            v-for="(item, index) in rssConfig"
            :key="index"
            class="flex flex-wrap"
            :class="{ 'font-bold my-2': item.isCategory, 'ml-4': !item.isCategory }"
          >
            <h2 class="w-48">{{ Object.keys(item)[0] }}</h2>
            <OLink :href="Object.values(item)[0]" class="break-all font-normal" color-scheme="primary">
              {{ LINK_PROD }}{{ Object.values(item)[0] }}
            </OLink>
          </li>
        </ul>
      </div>
    </div>
  </FullPageLayout>
</template>

<script>
import FullPageLayout from '~/modules/common/components/layout/FullPageLayout.vue';
import { LINK_PROD } from '~/constants/config';
import { rssConfig } from '~/constants/rssProxies';
import { OLink } from '~/modules/common/components/ui';

export default {
  components: { FullPageLayout, OLink },
  setup() {
    return { rssConfig, LINK_PROD };
  },
};
</script>

<style></style>
